import script from "./ModalDetallePedido.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDetallePedido.vue?vue&type=script&setup=true&lang=js"

import "./ModalDetallePedido.vue?vue&type=style&index=0&id=315ff555&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-315ff555"]])

export default __exports__